/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Enqueue_FailedInputs */

const vi_lot_label_enqueue_failed = /** @type {(inputs: Lot_Label_Enqueue_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi tem thất bại`)
};

/**

* @param {Lot_Label_Enqueue_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_enqueue_failed = /** @type {((inputs?: Lot_Label_Enqueue_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Enqueue_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_enqueue_failed(inputs)
});